import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const InnerBlock = lazy(() =>
  import('./DetailsBlock').then(m => ({default: m.DetailsBlock})),
)

export const detailsBlockInfo = B.blockInfo({...meta, Admin, InnerBlock})
